import React, { useEffect, useState, useRef } from 'react'
import PortalLoader from '@nexidigital/portalloader'
import { useLocation } from 'react-router-dom'
import { generateCodeChallenge, codeVerifier, generateRandomString, getAuth } from './AcgUtils'

const AcgFlow = () => {
  const [challenge, setChallenge] = useState('')
  const location = useLocation()
  const hasCalledAuth = useRef(false)

  const storedCodeVerifier = window.localStorage.getItem('codeVerifier')
  const effectiveCodeVerifier = storedCodeVerifier || codeVerifier

  const isLoginMos = location.pathname.includes('/login-mos')

  useEffect(() => {
    const initializeAuth = async () => {
      const generatedChallenge = await generateCodeChallenge(effectiveCodeVerifier)
      setChallenge(generatedChallenge)
    }
    initializeAuth()
  }, [])

  useEffect(() => {
    if (challenge && !hasCalledAuth.current) {
      hasCalledAuth.current = true
      const authorizePayload = {
        codeChallenge: challenge,
        nonce: generateRandomString(16),
        codeVerifier: effectiveCodeVerifier,
        isLoginMos
      }
      getAuth(authorizePayload)
    }
  }, [challenge, isLoginMos])

  return (
    <>
      <div style={{ height: '100vh' }}>
        <PortalLoader circular centered />
      </div>
    </>
  )
}

export default AcgFlow
